import { computed, readonly, ref, type App } from 'vue'
import { LDPlugin, LD_FLAG, LD_READY } from 'launchdarkly-vue-client-sdk'
import { Constants } from '@/cfg/constants'

// Flags are toggled per LaunchDarkly environment only, so every visitor is
// evaluated as an anonymous context (the SDK persists a random key for it).
export default {
    install(app: App) {
        if (!Constants.LD_CLIENT_ID) {
            // No LaunchDarkly environment configured (e.g. local without .env):
            // keep useLDFlag/useLDReady working and always return the default value.
            app.provide(LD_READY, readonly(ref(false)))
            app.provide(LD_FLAG, <T>(_key: string, defaultValue?: T) => computed(() => defaultValue as T))
            return
        }

        app.use(LDPlugin, {
            clientSideID: Constants.LD_CLIENT_ID,
            context: {
                kind: 'user',
                anonymous: true,
                region: Constants.REGION,
            },
        })
    },
}
